module.exports = __webpack_public_path__ + "media/bgm.63664969.mp3";